var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8.71396C15 11.081 11.866 13 8 13C4.134 13 1 11.081 1 8.71396C1 6.34696 4.134 4.42896 8 4.42896C11.866 4.42896 15 6.34696 15 8.71396Z",
    stroke: "#171923",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74969 8.71409C9.76431 9.425 9.34734 10.0741 8.6947 10.3563C8.04207 10.6386 7.28353 10.4979 6.77554 10.0003C6.26756 9.50279 6.11112 8.74734 6.37974 8.08898C6.64836 7.43062 7.28863 7.00025 7.99968 7.00009C8.45905 6.9953 8.9015 7.17319 9.22969 7.49463C9.55789 7.81607 9.74494 8.25473 9.74969 8.71409V8.71409Z",
    stroke: "#171923",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 4.429C7.25 4.84321 7.58579 5.179 8 5.179C8.41421 5.179 8.75 4.84321 8.75 4.429H7.25ZM8.75 1C8.75 0.585786 8.41421 0.25 8 0.25C7.58579 0.25 7.25 0.585786 7.25 1H8.75ZM14.7931 3.05471C14.9813 2.68571 14.8347 2.23403 14.4657 2.04586C14.0967 1.85769 13.645 2.00428 13.4569 2.37329L14.7931 3.05471ZM12.0199 5.19129C11.8317 5.5603 11.9783 6.01197 12.3473 6.20014C12.7163 6.38831 13.168 6.24172 13.3561 5.87271L12.0199 5.19129ZM2.54314 2.37329C2.35497 2.00428 1.90329 1.85769 1.53429 2.04586C1.16528 2.23403 1.01869 2.68571 1.20686 3.05471L2.54314 2.37329ZM2.64386 5.87271C2.83203 6.24172 3.28371 6.38831 3.65271 6.20014C4.02172 6.01197 4.16831 5.5603 3.98014 5.19129L2.64386 5.87271ZM8.75 4.429V1H7.25V4.429H8.75ZM13.4569 2.37329L12.0199 5.19129L13.3561 5.87271L14.7931 3.05471L13.4569 2.37329ZM1.20686 3.05471L2.64386 5.87271L3.98014 5.19129L2.54314 2.37329L1.20686 3.05471Z",
    fill: "#171923"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPassword);
export default __webpack_public_path__ + "static/media/viewPassword.66b56a408614b9454e0a7d6e321d5a11.svg";
export { ForwardRef as ReactComponent };